export default {
    mounted(el, binding) {
        const formatValue = (val) => {
            let value = String(val).replace(/,/g, '');
            if (!isNaN(value) && value !== '') {
                return new Intl.NumberFormat().format(value);
            }
            return val;
        };

        const findRealInput = () => {
            return el.querySelector('input') ||
                el.querySelector('.el-input__inner');
        };
        setTimeout(() => {
            const input = findRealInput();
            if (input) {
                input.value = formatValue(input.value);
            }
        });

        el.addEventListener('input', (e) => {
            const rawValue = e.target.value.replace(/,/g, '');
            if (!isNaN(rawValue)) {
                e.target.value = formatValue(rawValue);
            }
        });
    }
}
